import { makeStyles } from "@material-ui/core/styles"
const useStyles = makeStyles((theme) => ({
  heightsForm: {
    height: "75px",
  },
}))
export default useStyles
